"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var ContentFrameData = /*#__PURE__*/function () {
  function ContentFrameData(width, height) {
    (0, _classCallCheck2["default"])(this, ContentFrameData);
    (0, _defineProperty2["default"])(this, "_contentHeight", 0);
    (0, _defineProperty2["default"])(this, "_contentWidth", 0);
    this._contentHeight = height;
    this._contentWidth = width;
  }

  (0, _createClass2["default"])(ContentFrameData, [{
    key: "equals",
    value: function equals(inContentFrameData) {
      if (!ContentFrameData.isContentFrameData(inContentFrameData)) return false;
      if (this === inContentFrameData) return true;
      return this.contentHeight === inContentFrameData.contentHeight && this.contentWidth === inContentFrameData.contentWidth;
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this._contentHeight;
    }
  }, {
    key: "contentWidth",
    get: function get() {
      return this._contentWidth;
    }
  }], [{
    key: "isContentFrameData",
    value: function isContentFrameData(contentFrameData) {
      return contentFrameData instanceof ContentFrameData;
    }
  }]);
  return ContentFrameData;
}();

exports["default"] = ContentFrameData;